import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext';
import { useKycSettings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/useKycSettings.ts';
import { KycSettingsView } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/components/KycSettingsView';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const KycSettings = () => {
	const { mipId } = useRequiredParams('mipId');
	const mipManageController = useMIPManageContext();
	const mipData = mipManageController.mipData;
	const kycSettings = useKycSettings({ mipData, mipId });

	// Only while the row is still being fetched; an unconfigured programme renders its
	// defaults rather than a blank page.
	if (!kycSettings.settings) {
		return null;
	}

	const {
		settings,
		toggleSetting,
		bankAccountApproval,
		setBankAccountApproval,
		hasPermission,
		isLoading,
		certificationText,
	} = kycSettings;

	return (
		<KycSettingsView
			kycSettings={{
				settings,
				toggleSetting,
				bankAccountApproval,
				setBankAccountApproval,
				hasPermission,
				isLoading,
				certificationText,
			}}
		/>
	);
};
